import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BrowserWindowService } from '@services/browser-window.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const serverErrorInterceptor: HttpInterceptorFn = (request, next) => {
    const router = inject(Router);
    const dialog = inject(MatDialog);
    const browserWindowService = inject(BrowserWindowService);

    return next(request).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                return handleResponse(error, router, dialog, browserWindowService);
            }
            return throwError(() => error);
        }),
    );
};

function handleResponse(
    errorResponse: HttpErrorResponse,
    router: Router,
    dialog: MatDialog,
    browserWindowService: BrowserWindowService,
) {
    if (errorResponse.status === 500) {
        // navigate to 500 route
        router.navigate(['/error']);
        dialog.closeAll();
        return throwError(() => errorResponse);
    }
    if (errorResponse.status === 401 && errorResponse.error.message !== 'Unauthenticated') {
        // TODO: replace with silent token renewal and request retry in the future
        browserWindowService.reloadWindow();
    }

    return throwError(() => errorResponse);
}
